import {ACTION} from './constants';

let initialState={
    allGoals:{
        apiLoaded: false
    },
    goalsQuestion:{
        apiLoaded: false
    },
    riskQuestion:{
        apiLoaded: false
    },
    riskAppetite:{
        apiLoaded: false
    },
    basket:{
        apiLoaded: false
    },
    riskAppetitesList:{
        apiLoaded: false
    },
    allBaskets:{
        apiLoaded: false
    },
    savePreLoginResponse: {
        apiLoaded: false,
    },
    getBasketSchemes: {
        apiLoaded: false,
    },
    otpVerificationData: {
        apiLoaded: false,
    },
    goalSuggestion: {
        apiLoaded: false,
    },
    trendingFundData:{
        apiLoaded: false,
    },
    homepageData:{
        apiLoaded: false,
    },
    mdMessageData: {
        apiLoaded: false,
    },
    kycVerificationData:{
        apiLoaded: false,
    },
    youtubeShortsData:{
        apiLoaded: false,
    }
};

export default function homePageReducer(state=initialState, action) {
    switch (action.type) {
        case ACTION.GET_HOME_CONTENT :
            return {...state, ...action.data};
        
        case ACTION.GET_GOALS_CONTENT :
            return {...state, allGoals:{...action.data, apiLoaded: true}};

        case ACTION.CLEAN_GOALS_QUESTIONS:
            return {...state, goalsQuestion: {apiLoaded: false}};
            
        case ACTION.GET_GOAL_QUESTION :
            return {...state, goalsQuestion:{...action.data, apiLoaded: true}};
        
        case ACTION.GET_GOAL_SUGGESTION :
            return {...state, goalSuggestion:{...action.data, apiLoaded: true}};
        
        case ACTION.VERIFY_PAN :
            return {...state, panVerification:{...action.data, apiLoaded: true}};
        
        case ACTION.VERIFY_KYC :
            return {...state, kycVerificationData:{...action.data, apiLoaded: true}};
        
        case ACTION.VERIFY_OTP :
            return {...state, otpVerificationData:{...action.data, apiLoaded: true}};
        
        case ACTION.RESEND_OTP :
            return {...state, otpResendData:{...action.data, apiLoaded: true}};

        case ACTION.CLEAN_GOALS_CONTENT:
            return {...initialState};

        case ACTION.GET_RISK_QUESTION_ANS:
            return {...state, riskQuestion:{...action.data, apiLoaded: true}};

        case ACTION.EVALUATE_RISK_APPETITE:
            return {...state, riskAppetite:{...action.data, apiLoaded: true}}    

        case ACTION.GET_BASKET_RECOMMENDATION:
            return {...state, basket:{...action.data, apiLoaded: true}}

        case ACTION.GET_RISK_APPETITES_LIST:
            return {...state, riskAppetitesList:{...action.data, apiLoaded: true}}

        case ACTION.SAVE_PRE_LOGIN_DATA:
            return {...state, savePreLoginResponse:{...action.data, apiLoaded: true}}

        case ACTION.VALIDATE_BASKET_SCHEMES:
            return {...state, getBasketSchemes:{...action.data, apiLoaded: true}}   
    
        case ACTION.GET_HOMEPAGE_DATA:
            return {...state,homepageData:{... action.data,apiLoaded: true}};

        case ACTION.CLEAN_RISK_CONTENT:
            return {...state, riskQuestion: initialState.riskQuestion, riskAppetite: initialState.riskAppetite, riskAppetitesList: initialState.riskAppetitesList };

        case ACTION.GET_TRENDING_FUND_DATA:
            return {...state, trendingFundData:{...action.data, apiLoaded: true}};

        case ACTION.CLEAN_AUTH_CONTENT:
            return {...state, kycVerificationData:{ apiLoaded: false }};
        case ACTION.IMP_ANNOUNCEMENT_META:
            return {...state, impAnnouncement: action.data};
        case ACTION.GET_YOUTUBE_SHORTS_DATA:
            return {...state, youtubeShortsData:{ ...action.data, apiLoaded: true}};
        default:
            return state;
    }
}
